import { render, staticRenderFns } from "./jiXiuList.vue?vue&type=template&id=1882fe81&"
import script from "./jiXiuList.vue?vue&type=script&lang=js&"
export * from "./jiXiuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports